<template>
  <div class="__MyAccount-Mfa">
    <CTitle lighter margin-bottom>
      {{ $t('Multi-factor authentication') }}
      <template v-slot:subtitle>
        {{
          $t(
            'Set up Multi-factor authentication. If enabled, you will be required to enter the verification code when logging in.'
          )
        }}
      </template>
    </CTitle>

    <Button
      @click="mfa.deactivateModalVisible = true"
      color="negative"
      :loading="mfa.loading"
      v-if="mfaStatus === 'verified'"
      :label="$t('Deactivate')"
    />
    <Button :label="$t('Activate')" @click="enableMfa" :loading="mfa.loading" v-else />
    <Banner type="danger" v-if="mfa.errorMsg">{{ mfa.errorMsg }}</Banner>

    <!--Modal-->
    <ModalActivateMfa v-model="mfa.activateModalVisible" />
    <ModalDeactivateMfa v-model="mfa.deactivateModalVisible" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Button from '@design-system/components/Button.vue';
import Banner from '@design-system/components/Banner.vue';

import CTitle from '@/components/uikit/CTitle';

import ModalActivateMfa from './MyAccountMfaDialogActivate';
import ModalDeactivateMfa from './MyAccountMfaDialogDeactivate';

const messages = {
  en: {
    Security: 'Security',
    'Multi-factor authentication': 'Multi-factor authentication',
    'Set up Multi-factor authentication. If enabled, you will be required to enter the verification code when logging in.':
      'Set up Multi-factor authentication. If enabled, you will be required to enter the verification code when logging in.',
    Activate: 'Activate',
    Deactivate: 'Deactivate',
  },
  ja: {
    Security: 'セキュリティ',
    'Multi-factor authentication': '2段階認証',
    'Set up Multi-factor authentication. If enabled, you will be required to enter the verification code when logging in.':
      '2段階認証を設定します。有効にするとログインの際に認証コードの入力が必要になります。',
    Activate: '2段階認証を有効化',
    Deactivate: '2段階認証を無効化',
  },
};

export default {
  name: 'MyAccountMfa',
  components: { ModalActivateMfa, ModalDeactivateMfa, Button, Banner, CTitle },
  i18n: { messages },
  data() {
    return {
      mfa: {
        loading: false,
        errorMsg: null,
        activateModalVisible: false,
        deactivateModalVisible: false,
      },
    };
  },
  computed: mapState('mfa', {
    mfaStatus: state => state.data.status,
  }),
  methods: {
    ...mapActions('mfa', {
      getMfaStatus: 'getStatus',
      postMfa: 'post',
      deleteMfa: 'delete',
    }),
    setMfaErrorMsg(error, errorMsg) {
      console.log(error);
      this.mfa.errorMsg = errorMsg;
      setTimeout(() => {
        this.mfa.errorMsg = null;
      }, 5000);
    },
    async enableMfa() {
      try {
        this.mfa.loading = true;
        await this.postMfa();
        this.mfa.activateModalVisible = true;
      } catch (error) {
        console.log(error);
        this.setMfaErrorMsg(error, this.$t('Error Occurred'));
      } finally {
        this.mfa.loading = false;
      }
    },
  },
  created() {
    this.getMfaStatus();
  },
};
</script>

<style lang="scss" scoped>
.__MyAccount-Mfa {
  margin-bottom: $space-xl;
}
</style>
